import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Env from './Env';
import axios from 'axios';
import { AuthProvider } from 'react-oidc-context';
import './index.scss';
import AntdSchemeFilter from './pages/components/AntdSchemeFilter';

/**
 * 
 *  草图:
 * https://drive.google.com/file/d/1A5eaCrRfOVdhwUyGBUBZ1MelBWmledDS/view?usp=sharing
 * 
    Git Repo:
    https://github.com/roundblock-randd/leazy-translation-frontend

    已经deploy到Azure了：
    https://icy-bay-07b93b71e.6.azurestaticapps.net/

    React Version: 18.2.0
    node version: v23.3.0
    npm version: 10.9.0

    draw.io 流程图里面的链接已更新。userpool已经开放注册，你应该可以用那个login page去注册账号。

    Dev环境的API Gateway： https://jp2w7m1c1j.execute-api.us-west-2.amazonaws.com/prod

    API Collection:  

    https://leazy-backend-apis.postman.co/workspace/Leazy-Backend-APIs-Workspace~25e169a9-d6ce-4059-9765-19626f456a4c/collection/3037640-559bbdad-cad1-4d7f-a0ed-aabe6be7d1e4?action=share&creator=3037640

    里面的API Gateway 和 id token是我开发用的stage，你可以先用它来看一下接口定义

    Canvas Editor Demo: https://github.com/roundblock-randd/translation-demo
 * 
 * 
 */

const gateway = process.env.REACT_APP_API_BASE_URL
const cognitoClientId = process.env.REACT_APP_COGNITO_CLIENT_ID
const cognitoAuthority = process.env.REACT_APP_COGNITO_AUTHORITY
const cognitoDomain = process.env.REACT_APP_NIGNITO_DOAMIN || "https://leazy-translation-dev.auth.us-west-2.amazoncognito.com"
if(Env.DEBUG){
  console.log("======env======")
  console.log("gateway: ", gateway)
  console.log("cognitoAuthority: ", cognitoAuthority)
  console.log("cognitoClientId: ", cognitoClientId)
  console.log("cognitoDomain: ", cognitoDomain)
  console.log("======env======")
}
axios.defaults.baseURL = gateway
// axios.defaults.withCredentials = true;
// https://leazy-translation-dev.auth.us-west-2.amazoncognito.com/logout?client_id=6503mhvb2eb357k5o0e6pc4lqs&logout_uri=http://localhost:3000

const oidcConfig = {
  authority: cognitoAuthority, // 你的身份验证服务器地址
  client_id: cognitoClientId, // 你的客户端 ID
  redirect_uri: `${window.location.origin}/callback`, // 重定向 URI，通常指向应用的回调路由
  scope: "openid profile email", // 请求的范围
  response_type: "code", // 响应类型，通常为 "code" 表示授权码流程
  // 其他可选配置
  post_logout_redirect_uri: `${cognitoDomain}/logout?client_id=${cognitoClientId}&logout_uri=${window.location.origin}`, // 登出后重定向的 URI
  onSigninCallback: () => {
    // 登录成功后清理 URL 中的查询参数
    window.history.replaceState({}, document.title, window.location.pathname);
  }, // 登录成功后清理 URL 中的 payload
};


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  // </React.StrictMode>
  <AuthProvider {...oidcConfig}>
    <AntdSchemeFilter>
      <App />
    </AntdSchemeFilter>
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
